<template>
  <div id="app">
    <nav class="nav-fixed d-none d-md-block" :class="navBarClass">
      <ul class="list-inline">
        <li class="list-inline-item">
          <b-button v-scroll-to="'#point-2'" size="lg" class="btn-clear">シャツの特徴</b-button>
        </li>
        <li class="list-inline-item">
          <b-button v-scroll-to="'#story-2'" size="lg" class="btn-clear">ストーリー</b-button>
        </li>
        <li class="list-inline-item">
          <b-button v-scroll-to="'#chart'" size="lg" class="btn-clear">サイズ・仕様</b-button>
        </li>
        <li class="list-inline-item">
          <b-button v-scroll-to="'#footer'" size="lg" class="btn-clear">購入</b-button>
        </li>
      </ul>
    </nav>
    <Feature />
    <Point />
    <Story />
    <Chart />
    <Footer />
  </div>
</template>

<script>
import Feature from './components/Feature.vue'
import Point from './components/Point.vue'
import Story from './components/Story.vue'
import Chart from './components/Chart.vue'
import Footer from './components/Footer.vue'
import ScrollReveal from 'scrollreveal'

export default {
  name: 'App',
  components: {
    Feature, Point, Story, Chart, Footer
  },
  data() {
    return {
      scrollY: 0
    }
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll)
    setTimeout(() => {
      ScrollReveal().reveal('.v-scroll-reveal')
    
      ScrollReveal().reveal('.scroll-reveal-up', { 
        duration: 800, 
        origin: 'bottom', 
        distance: '50px'
      })
      ScrollReveal().reveal('.scroll-reveal-expand', { 
        duration: 800, 
        origin: 'bottom', 
        distance: '20px',
        scale: '0.5',
        delay: '400'
      })
    }, 500);
  },
  computed: {
    navBarClass() {
      if(this.scrollY > window.innerHeight) {
        return 'dark'
      }
      return ''
    }
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-fixed {
  position: fixed;
  z-index: 20;
  top: 50px;
  left: 50px;
}
</style>
